import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { styles } from './styles';
import { Spinner } from '@ebh/capsule';
import cookiesManager from '../../utils/cookies';
import { AUTH_KEYS, USER_DETAILS } from '../../utils/cookies/keys';
import { useRefreshToken } from '../../api/hooks/login/use-refresh-token';
import { decodeAccessToken, normalizeName } from '../../utils/login';

const Sso = () => {
  const [params] = useSearchParams();
  const token = params.get('token');
  const redirect = params.get('redirect');
  const navigate = useNavigate();
  const userName = params.get('username');

  const { refreshToken } = useRefreshToken({
    onSuccess: async (data) => {
      const decoded = await decodeAccessToken(data.data?.accessToken);
      await cookiesManager.setMultiple(
        [
          {
            key: AUTH_KEYS.ACCESS_TOKEN,
            value: data?.data?.accessToken,
          },
          {
            key: AUTH_KEYS.REFRESH_TOKEN,
            value: data?.data?.refreshToken,
          },
          {
            key: AUTH_KEYS.EXPIRY_TIME,
            value: data?.data?.expiryTime?.toString(),
          },
          {
            key: AUTH_KEYS.VAPISTXID,
            value: data?.data?.vapisTxId,
          },
          {
            key: USER_DETAILS.IS_SSO,
            value: 'true',
          },
          { key: USER_DETAILS.USERNAME, value: decoded.username },
          { key: USER_DETAILS.FULL_NAME, value: normalizeName(decoded.name) },
          { key: USER_DETAILS.LOGIN_TYPE, value: decoded.loginType },
          { key: USER_DETAILS.USER_ID, value: decoded.userId },
          { key: USER_DETAILS.USER_SEQ_ID, value: decoded.userSeqId },
          {
            key: USER_DETAILS.LEGAGY_USER_SEQ_ID,
            value: String(decoded.legacyUserSeqId),
          },
          { key: USER_DETAILS.GROUP_ID, value: decoded.userMetadata?.groupId },
          {
            key: USER_DETAILS.SOURCE_TYPE,
            value: decoded.sourceType ?? 'HR_PORTAL',
          },
        ],
        {
          path: '/',
        },
      );
      navigate(redirect ?? '/', {
        replace: true,
      });
    },
    onError: () => {
      navigate(-1);
    },
  });

  useEffect(() => {
    if (token) {
      refreshToken({
        loginType: 'COR',
        username: userName ?? '',
        ssoToken: token,
      });
    }
  }, [token]);

  return (
    <div css={styles.container}>
      <Spinner css={styles.spinner} size="4em" stroke={2} />
      <span css={styles.text}>Redirecting to HR Portal...</span>
    </div>
  );
};

export default Sso;
